"use client";

import Section from "@/components/static/Section";
import Headline from "@/components/static/Headline";
import Text from "@/components/static/Text";
import parse from "html-react-parser";
import Image from "next/image";
import Buttons from "@/components/static/Buttons";
import Button from "@/components/static/Button";
import { SectionProps, HeadlineProps, ImageProps, ButtonProps, Repeater } from "@/lib/types";
import { cn } from "@/lib/utils";

type Content = {
    bgIMage: ImageProps;
    headline: HeadlineProps;
    text: string;
    image: ImageProps;
    settings: SectionProps;
    buttons: ButtonProps[];
    inners: Repeater<{ avatar: ImageProps }>;
};

export default function CTA_5({ content }: { content: Content }) {
    return (
        <Section dataComponent='CTA_5' settings={content.settings}>
            <div className='relative overflow-hidden min-h-[720px] h-full'>
                <div className='absolute size-full'>
                    <Image
                        src={content.bgIMage.url}
                        height={content.bgIMage.height}
                        width={content.bgIMage.width}
                        alt={content.bgIMage.alt}
                        className='size-full object-cover'
                    />
                    <div className='absolute inset-0 bg-[linear-gradient(0deg,rgba(0,0,0,0.39)_0%,rgba(0,0,0,0.39)_100%)]' />
                </div>
                <div className='container h-full'>
                    <div className='relative flex flex-col justify-center min-h-[720px] max-w-lg py-10 lg:py-0'>
                        <div
                            className={cn(
                                "flex flex-wrap lg:flex-nowrap items-center mb-6",
                                content?.inners && "gap-x-6",
                            )}
                        >
                            <div className='flex flex-shrink-0 mb-4 lg:mb-0'>
                                {content?.inners &&
                                    content?.inners?.map((item, key: number) => (
                                        <Image
                                            key={key}
                                            src={item.avatar.url}
                                            height={item.avatar.height}
                                            width={item.avatar.width}
                                            alt={item.avatar.alt}
                                            className='size-12 rounded-full -ml-4 first:-ml-0'
                                        />
                                    ))}
                                {content?.inners && (
                                    <div className='flex items-center justify-center -ml-4 size-12 rounded-full bg-stroke text-white'>
                                        +1.
                                    </div>
                                )}
                            </div>
                            {content.text && (
                                <Text className='prose md:text-md text-white'>
                                    {parse(content.text)}
                                </Text>
                            )}
                        </div>
                        <Headline tag={content.headline.tag} topline={content.headline.topline}>
                            <div className='text-h0 font-medium text-white leading-[120%]'>
                                {content.headline.title}
                            </div>
                        </Headline>
                        {content.buttons && (
                            <Buttons className='buttons gap-x-8 mt-8'>
                                {content?.buttons?.map((button, index: number) => {
                                    return (
                                        <Button
                                            as='link'
                                            href={button?.link?.url}
                                            type={button?.type}
                                            key={index}
                                        >
                                            {button?.link?.title}
                                        </Button>
                                    );
                                })}
                            </Buttons>
                        )}
                    </div>
                </div>
            </div>
        </Section>
    );
}
